import { CompanyType } from "../../../Models/Company";

/**
 * Returns the URL path segment corresponding to a given company type.
 *
 * @param {CompanyType} type - The type of the company. 
 * Can be one of: 'CUSTOMER', 'AFILIATE', or 'ORGANIZATION'.
 *
 * @returns {string | undefined} The corresponding path segment as a string.
 * Returns `undefined` if the provided type is not recognized.
 *
 * @example
 * getCompanyPath("CUSTOMER"); // returns "customers"
 * getCompanyPath("AFILIATE"); // returns "affiliates"
 */
export const getCompanyPath = (type: CompanyType) => {
    const path = {
        CUSTOMER: "customers",
        AFILIATE: "affiliates",
        ORGANIZATION: "organizations",
        MASTER_ORGANIZATION: "master-organizations"
    };
    return path[type];
};
